import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';

import ButtonInput from "../../common/ButtonInput";
import MSGDialogue from '../../components/Dialogue';
import axios from 'axios';
import { APIurl } from '../../App';

export default function AddKeys() {

  /* ========= STATE ========= */
  const [email, setEmail] = useState("");
  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [logging, setLogging] = useState(false);

  /* ========= SUBMIT ========= */
  const process = (event) => {
    
    event.preventDefault();

    setLogging(false);
    setLogingmsg("");


    if (!email.trim()) {
      setLogingmsg("User email is required");
      setColors("text-white bg-danger");
      setLogging(true);
      return;
    }

    const owner = localStorage.getItem("email"); // logged-in mentor
    const cmd = "addkey";


    if (!owner) {
      setLogingmsg("Session expired. Please log in again.");
      setColors("text-white bg-danger");
      setLogging(true);
      return;
    }


    axios.post(APIurl, {
      email: email,
      owner: owner,
      cmd: cmd
    })
    .then((response) => {
      const res = response.data;

      setLogingmsg(res.data);
      setColors(res.success ? "text-white bg-success" : "text-white bg-danger");
      setLogging(true);

      if (res.success) {
        setEmail(""); // clear input
      }
    })
    .catch((error) => {
      console.error("Axios error:", error);
      setLogingmsg("An error occurred. Please try again.");
      setColors("text-white bg-danger");
      setLogging(true);
    });
  };

  /* ========= UI ========= */
  return (
    <>
      {logging && (
        <MSGDialogue
          msg={loginmsg}
          id="msg-add-key"
          colors={colors}
        />
      )}

      <div className='mr-0 ml-0 p-2 mt-2 mb-0'>
        <h3>Create License Key</h3>
      </div>

      <Container fluid className='d-flex flex-row mt-2 w-100 home-cards'>
        <div className='register-container mx-auto my-3 p-3 bg-white rounded animate__animated animate__fadeInDown'>
          
          <form onSubmit={process}>
            <div className="theme-color h3">Create Key Below</div>
            <hr />

            {/* User Email */}
            <div className='form-group row'>
              <div className='col-md-5'><b>User Email:</b></div>
              <div className='col-md-6'>
                <input
                  type="email"
                  className='form-control'
                  placeholder='Enter user email address'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <ButtonInput value="Add Key" active="btn-deactive my-3" />
          </form>
        </div>
      </Container>
    </>
  );
}
